import { Text } from '@frameio/vapor';
import styles from './SettingRow.module.css';

export const SettingRow = ({
  title,
  field,
}: {
  title: string | React.ReactNode;
  field: React.ReactNode;
}) => {
  return (
    <div className={styles.row}>
      <div className={styles.label}>
        {typeof title === 'string' ? (
          <Text color="primary" variant="body">
            {title}
          </Text>
        ) : (
          title
        )}
      </div>
      <div className={styles.field}>{field}</div>
    </div>
  );
};
